import _ from "lodash";

const promises: Record<string, Promise<any> | null> = {};

function makeRequest(
  namespace: string,
  requestPromise: Promise<any>,
  resolve: any,
  reject: any = _.noop
) {
  promises[namespace] = requestPromise;
  return requestPromise.then(
    (...args: any[]) => {
      if (promises[namespace] === requestPromise) {
        resolve.apply(null, args);
      }
    },
    (...args: any[]) => {
      if (promises[namespace] === requestPromise) {
        reject.apply(null, args);
      }
    }
  );
}

function clearPromise(namespace: string) {
  promises[namespace] = null;
}

export default {
  makeRequest,
  clearPromise
};
